import React from 'react';
import { Backdrop, CircularProgress, Typography, Box, Paper } from '@mui/material';

const RestoringOverlay = ({ show }) => {
    return (
        <Backdrop
            sx={{
                color: '#fff',
                zIndex: 9999,
                backgroundColor: 'rgba(0, 0, 0, 0.85)'
            }}
            open={show}
        >
            <Paper
                elevation={6}
                sx={{
                    padding: 4,
                    borderRadius: 3,
                    backgroundColor: '#fff',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    minWidth: '400px',
                    boxShadow: 'var(--shadow-lg)'
                }}
            >
                <CircularProgress size={60} sx={{ color: '#3B82F6' }} />
                <Typography
                    variant="h5"
                    component="div"
                    sx={{
                        mt: 3,
                        fontWeight: 600,
                        color: '#1e293b',
                        fontFamily: 'var(--font-family-base)'
                    }}
                >
                    Restaurando y reiniciando el sistema...
                </Typography>
                <Typography
                    sx={{
                        mt: 1,
                        color: '#64748b',
                        fontFamily: 'var(--font-family-base)'
                    }}
                >
                    Por favor, espere. Esto puede tardar unos momentos.
                </Typography>
            </Paper>
        </Backdrop>
    );
};

export default RestoringOverlay;

